module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/documentos/documentos.component.css
// module id = ./src/app/components/documentos/documentos.component.css
// module chunks = main